import styled from 'styled-components';
import { CenterFlex, FlexColumn } from '../Flex';
import { useStyledTheme, WebIcon } from '../../..';

const FooterContainer = styled.div`${({ theme }) => `
  width: 100%;
  margin: 0 auto;
  padding: 0 calc(${theme.padding[11]} - ${theme.padding[9]});
  background-color: ${theme.colours.primary[1]};
  box-sizing: border-box;
`}`;

const FooterWrapper = styled.div`${({ theme }) => `
  color: ${theme.colours.neutral[10]};
  // gap: ${theme.padding[7]};
`}`;
const FooterTop = styled.div` ${({ theme }) => `
  display:flex;
  align-items: center;
  gap: calc(${theme.padding[10]} + ${theme.borderWidth[1]});
  padding-top:${theme.padding[7]};
  padding-bottom:${theme.padding[7]};
  border-bottom: ${theme.borderWidth[1]} solid ${theme.colours.secondary[1]};
`}`;
const ItemContainer = styled(CenterFlex)` ${({ theme }) => `
   width:auto;
   gap:${theme.padding[1]};
`}`;
const TextLink = styled.a`${({ theme }) => `
 color:${theme.colours.neutral[10]};
 font-family: 'Open Sans';
 font-size: ${theme.fontSize[2]};
 font-weight: ${theme.fontWeight.normal};
 line-height: ${theme.fontSize[6]};
 text-decoration:none;
 &:hover {
  text-decoration: underline;
  }
`}`;
const TextUnderlinne = styled.a`${({ theme }) => `
  color:${theme.colours.neutral[10]};
  font-family: 'Open Sans';
  font-size: ${theme.fontSize[1]};
  font-weight: ${theme.fontWeight.normal};
  line-height: ${theme.padding[4]};
  text-decoration: underline;
`}`;
const IconItem = styled.i`${({ theme }) => `
  font-size: ${theme.padding[4]};
  color: ${theme.colours.secondary[1]};
  display:flex;
  justify-content:center;
  align-items: center;
`}`;
const TextBottom = styled.p` ${({ theme }) => `
  color:${theme.colours.neutral[10]};
  font-family: 'Open Sans';
  font-size: ${theme.fontSize[1]};
  font-weight: ${theme.fontWeight.normal};
  line-height: ${theme.padding[4]};
  text-align: left;
`}`;
const FooterBottom = styled(FlexColumn)` ${({ theme }) => `
  justify-content:space-between;
  gap:${theme.padding[6]};
  padding-top:${theme.padding[7]};
  padding-bottom:${theme.padding[7]}};
`}`;

export const SmallFooterWrapper = styled.div` ${({ theme }) => `
    width: 100%;
    background: ${theme.colours.primary[1]}; 
    box-sizing: border-box;
`}`;

export const SmallFooterContainer = styled.div` 
  width: 100%;
`;

export function Footer() {
  const theme = useStyledTheme();
  return (
    <FooterContainer>
      <FooterWrapper>
        <FooterTop>
          <ItemContainer>
            <IconItem className="mi-call" />
            <TextLink href="tel:+4402038323455">0203 832 3455</TextLink>
          </ItemContainer>
          <ItemContainer>
            <IconItem className="mi-email" />
            <TextLink href="mailto:salessupport@equifinance.co.uk">salessupport@equifinance.co.uk</TextLink>
          </ItemContainer>
          <ItemContainer>
            <WebIcon fill={theme.colours.secondary[1]} />
            <TextLink target="_blank" rel="noopener" href="https://www.equifinance.co.uk">equifinance.co.uk</TextLink>
          </ItemContainer>
        </FooterTop>
        <FooterBottom>
          <TextBottom>{`© ${new Date().getFullYear()} Equifinance Ltd`}</TextBottom>
          <TextBottom>
            This website is for intermediary use only and is not intended to promote Equifinance’s products or services to consumers. Consumers who are considering taking out a mortgage should seek information and advice from a firm which is regulated by the Financial Conduct Authority and is authorised to provide services in relation to taking out a mortgage. Equifinance Limited are registered in England & Wales under Company number 07324100, registered address 3rd Floor, East One Building, 22 Commercial Street, London, England, E1 6LP. Equifinance Limited is authorised and regulated by the Financial Conduct Authority under reference number 717913. We are a member of the Finance and Leasing Association and subscribe to its&nbsp;
            <TextUnderlinne
              target="_blank"
              rel="noopener noreferrer"
              href="https://fla.org.uk/consumer-finance/consumer-information/lending-code/"
            >
              Lending Code.
            </TextUnderlinne>
          </TextBottom>
        </FooterBottom>
      </FooterWrapper>
    </FooterContainer>
  );
}
